import { createFileRoute } from '@tanstack/react-router'
import { CatalogPage } from '@features/admin/catalog'

export const Route = createFileRoute('/admin/catalog')({
  component: RouteComponent,
})

function RouteComponent() {
  return <CatalogPage />
}
